module.exports = __webpack_public_path__ + "img/84_Intrebari_bogoslovesti_Bucuresti_1741_foaie_de_titlu.903c266f.jpg";